import { useEffect, useState } from "react";
import api, { formatBRL } from "@/lib/api";
import { Briefcase, Trophy, TrendingUp, Plus, X } from "lucide-react";
import { toast } from "sonner";

const STATUS = [
  { id: "novo", label: "Novo", color: "#64748B" },
  { id: "contato", label: "Em contato", color: "#0EA5E9" },
  { id: "proposta", label: "Proposta", color: "#F59E0B" },
  { id: "ganho", label: "Ganho", color: "#10B981" },
  { id: "perdido", label: "Perdido", color: "#EF4444" },
];

export default function VendedorDashboard() {
  const [stats, setStats] = useState({ total_leads: 0, by_status: {}, pipeline_value: 0, won_value: 0, commission: 0 });
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", phone: "", plan_interest: "gold", value: "", notes: "" });

  const load = async () => {
    const s = await api.get("/dashboard/vendedor").then(r=>r.data).catch(()=>({by_status:{}}));
    setStats(s);
  };
  useEffect(()=>{ load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post("/leads", { ...form, value: parseFloat(form.value || 0) });
      toast.success("Lead cadastrado!");
      setForm({ name: "", email: "", phone: "", plan_interest: "gold", value: "", notes: "" });
      setShowForm(false);
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Erro"); }
  };

  const moveLead = async (lid, newStatus) => {
    await api.put(`/leads/${lid}/status`, null, { params: { status: newStatus } });
    load();
  };

  return (
    <div className="space-y-8" data-testid="vendedor-dashboard">
      <div className="grid sm:grid-cols-4 gap-5">
        <div className="kpi-tile" data-testid="kpi-leads">
          <div className="text-xs uppercase tracking-widest text-slate-500 font-bold">Leads totais</div>
          <div className="font-display text-3xl font-black text-[#0E2A5C]">{stats.total_leads}</div>
        </div>
        <div className="kpi-tile" data-testid="kpi-pipeline">
          <div className="text-xs uppercase tracking-widest text-slate-500 font-bold">Pipeline</div>
          <div className="font-display text-3xl font-black text-[#0E2A5C]">{formatBRL(stats.pipeline_value)}</div>
        </div>
        <div className="kpi-tile" data-testid="kpi-ganhos">
          <div className="text-xs uppercase tracking-widest text-slate-500 font-bold">Vendas fechadas</div>
          <div className="font-display text-3xl font-black text-emerald-600">{formatBRL(stats.won_value)}</div>
          <div className="text-xs text-slate-500 flex items-center gap-1"><Trophy className="h-3 w-3" /> ganho</div>
        </div>
        <div className="kpi-tile" data-testid="kpi-comissao">
          <div className="text-xs uppercase tracking-widest text-slate-500 font-bold">Comissão (10%)</div>
          <div className="font-display text-3xl font-black text-[#2A8FE0]">{formatBRL(stats.commission)}</div>
          <div className="text-xs text-slate-500 flex items-center gap-1"><TrendingUp className="h-3 w-3" /> a receber</div>
        </div>
      </div>

      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h2 className="font-display text-2xl font-bold text-[#0E2A5C] flex items-center gap-2"><Briefcase className="h-6 w-6" /> Pipeline de vendas</h2>
          <p className="text-sm text-slate-500">Arraste lead clicando nos botões de status</p>
        </div>
        <button onClick={()=>setShowForm(s=>!s)} className="btn-primary text-sm" data-testid="add-lead-button">
          {showForm ? <><X className="h-4 w-4" /> Fechar</> : <><Plus className="h-4 w-4" /> Novo lead</>}
        </button>
      </div>

      {showForm && (
        <form onSubmit={create} className="card-soft p-6 grid sm:grid-cols-2 gap-3" data-testid="lead-form">
          <input required placeholder="Nome do lead" value={form.name} onChange={(e)=>setForm({...form, name: e.target.value})} className="px-3 py-2.5 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0]" data-testid="lead-name" />
          <input type="email" placeholder="E-mail" value={form.email} onChange={(e)=>setForm({...form, email: e.target.value})} className="px-3 py-2.5 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0]" data-testid="lead-email" />
          <input placeholder="Telefone" value={form.phone} onChange={(e)=>setForm({...form, phone: e.target.value})} className="px-3 py-2.5 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0]" data-testid="lead-phone" />
          <select value={form.plan_interest} onChange={(e)=>setForm({...form, plan_interest: e.target.value})} className="px-3 py-2.5 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0]" data-testid="lead-plan">
            <option value="gold">Gold</option><option value="diamante">Diamante</option><option value="corporativo">Corporativo</option>
          </select>
          <input type="number" step="0.01" placeholder="Valor potencial (R$)" value={form.value} onChange={(e)=>setForm({...form, value: e.target.value})} className="px-3 py-2.5 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0]" data-testid="lead-value" />
          <input placeholder="Observações" value={form.notes} onChange={(e)=>setForm({...form, notes: e.target.value})} className="px-3 py-2.5 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0]" data-testid="lead-notes" />
          <button type="submit" className="btn-primary sm:col-span-2" data-testid="lead-submit">Cadastrar lead</button>
        </form>
      )}

      <div className="grid lg:grid-cols-5 gap-4" data-testid="kanban">
        {STATUS.map(col => {
          const list = stats.by_status[col.id] || [];
          return (
            <div key={col.id} className="bg-slate-50 rounded-2xl p-3 min-h-[300px]" data-testid={`column-${col.id}`}>
              <div className="flex items-center justify-between px-2 pb-3 border-b border-slate-200">
                <div className="flex items-center gap-2">
                  <span className="h-2 w-2 rounded-full" style={{background: col.color}} />
                  <span className="font-bold text-sm text-[#0E2A5C]">{col.label}</span>
                </div>
                <span className="text-xs font-bold text-slate-500">{list.length}</span>
              </div>
              <div className="mt-3 space-y-2">
                {list.map(ld => (
                  <div key={ld.id} className="bg-white rounded-xl p-3 border border-slate-100 shadow-sm" data-testid={`lead-${ld.id}`}>
                    <div className="font-semibold text-[#0E2A5C] text-sm">{ld.name}</div>
                    <div className="text-xs text-slate-500">{ld.plan_interest.toUpperCase()} • {formatBRL(ld.value)}</div>
                    <div className="mt-2 flex flex-wrap gap-1">
                      {STATUS.filter(s=>s.id!==col.id).map(s => (
                        <button key={s.id} onClick={()=>moveLead(ld.id, s.id)} className="text-[10px] px-2 py-0.5 rounded-full border border-slate-200 hover:border-[#2A8FE0] hover:text-[#2A8FE0]" data-testid={`move-${ld.id}-${s.id}`}>
                          {s.label}
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
